export const ListQueryKey = 'fxConfigs';
export const DetailQueryKey = 'fxConfig';
export const Urls = {
  selectUrl: '/FxConfig/list',
  updateUrl: '/FxConfig/update',
  deleteUrl: '/FxConfig/delete',
  createUrl: '/FxConfig/create',
  detailUrl: '/FxConfig/info'
};